import { BreadcrumbItem, Field, FileUpload, Separator } from '@acme/foundation';
import {
  $application,
  applicationOpened,
  applicationReset,
} from '@entities/application';
import { useUnit } from 'effector-react';
import { Button, Card } from 'flowbite-react';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSetApplicationBreadcrumbs } from '../../application/ui/applicationLayout';

export const ApplicationTransferPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [files, setFiles] = useState<File[]>([]);

  const { application, onOpened, onReset } = useUnit({
    application: $application,
    onOpened: applicationOpened,
    onReset: applicationReset,
  });

  useEffect(() => {
    if (!id) return;
    onOpened({ id });
    return () => onReset();
  }, [id, onOpened, onReset]);

  const handleSendFiles = async () => {
    console.log('files', files);
  };

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      {
        label: 'Главная',
        onClick: () => navigate('/dashboard'),
      },
      ...(application
        ? [
            {
              label: application.code ?? '',
              onClick: () => navigate(`/application/${application.id}`),
            },
            {
              label: 'Перевод денежных средств',
            },
          ]
        : [
            {
              label: 'Заявка не найдена',
            },
          ]),
    ],
    [navigate, application]
  );

  useSetApplicationBreadcrumbs(breadcrumbItems);

  return (
    <>
      <Card>
        <h2 className="font-semibold text-xl">Перевод денежных средств</h2>

        <div className="grid grid-cols-4 gap-6">
          <Field label="Номер заявки" value={application?.code} />
          <Field label="Дата создания" value={123} />
        </div>

        <Separator className="-mx-6" />

        <h2 className="font-semibold text-xl">Реквизиты для перевода</h2>

        <div className="grid grid-cols-4 gap-6">
          <Field label="Номер заявки" value={application?.code} />
          <Field label="Дата создания" value={123} />
        </div>
      </Card>

      <Card>
        <div className="flex items-center justify-between">
          <h2 className="font-semibold text-xl">Перевод денежных средств</h2>

          <Button
            disabled={files.length === 0}
            color="primary"
            onClick={handleSendFiles}
          >
            Отправить
          </Button>
        </div>

        <FileUpload
          onFileSelect={(files) => setFiles(files)}
          accept=".pdf"
          maxSize={5}
          multiple={false}
        />
      </Card>
    </>
  );
};
